import type { QuizBuilderQuestionSchema } from '@repo/schemas/quiz/quizBuilderQuestion';

import { useWatch } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';

import { useQuizBuilder } from '@/context/quiz-builder';

export function useQuizBuilderQuestion() {
  const navigate = useNavigate();
  const { sectionIndex, questionIndex } = useParams();
  const { sectionsForm, saveDraftData } = useQuizBuilder();

  const sectionIndexNumber: number = sectionIndex ? parseInt(sectionIndex, 10) : -1;

  const questionIndexNumber: number = questionIndex ? parseInt(questionIndex, 10) : -1;

  const data: QuizBuilderQuestionSchema = useWatch({
    name: `content.${sectionIndexNumber}.questions.${questionIndexNumber}`,
    control: sectionsForm.control,
  });

  const onSubmit = (data: QuizBuilderQuestionSchema) => {
    sectionsForm.setValue(`content.${sectionIndexNumber}.questions.${questionIndexNumber}`, data);
    saveDraftData();
    navigate('../questions');
  };

  return {
    data,
    onSubmit,
    sectionIndex: sectionIndexNumber,
    questionIndex: questionIndexNumber,
  };
}
